// create user reducer

import {
    GET_USER_SIGN_IN_SUCCESS,
    GET_USER_SIGN_IN_FAIL,
    GET_USER_SIGN_IN_REQUEST,
    GET_USER_SIGN_UP_SUCCESS,
    GET_USER_SIGN_UP_FAIL,
    GET_USER_SIGN_UP_REQUEST,
    GET_DASHBOARD_REQUEST,
    GET_DASHBOARD_FAIL,
    GET_DASHBOARD_SUCCESS,
    GET_USER_PROFILE_REQUEST,
    GET_USER_PROFILE_SUCCESS,
    GET_USER_PROFILE_FAIL,
    GET_USER_SIGN_OUT_REQUEST,
    GET_USER_SIGN_OUT_SUCCESS,
    GET_USER_SIGN_OUT_FAIL,
} from "../types/user";

const initialState = {
    userInfo: null,
    dashboard: null,
    success:false,
    loading: false,
    error: null,
};
const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_SIGN_IN_REQUEST:
            return {
                ...state,
                loading: true,
                success:false,
                error:null
            };
        case GET_USER_SIGN_IN_SUCCESS:
            return {
                ...state,
                loading: false,
                userInfo: action.payload,
                success:true,
                error:null
            };
        case GET_USER_SIGN_IN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success:false

            };
        case GET_USER_SIGN_UP_REQUEST:
            return {
                ...state,
                loading: true,
                success:false,
                error:null
            };
        case GET_USER_SIGN_UP_SUCCESS:
            return {
                ...state,
                loading: false,
                userInfo: action.payload,
                success:true,
                error:null
            };
        case GET_USER_SIGN_UP_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success:false
            };
        case GET_USER_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error:null,
                success:false

            };
        case GET_USER_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                userInfo: action.payload,
                success:true
            };
        case GET_USER_PROFILE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success:false
            };
        case GET_USER_SIGN_OUT_REQUEST:
            return {
                ...state,
                loading: true,

            };
        case GET_USER_SIGN_OUT_SUCCESS:
            return {
                ...state,
                loading: false,
                userInfo: null,  
            };
        case GET_USER_SIGN_OUT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_DASHBOARD_REQUEST:
            return{
                ...state,
                loading:true,
                success:false
                
            };
        case GET_DASHBOARD_SUCCESS:
                return{
                    ...state,
                    loading:false,
                    dashboard:action.payload,
                    error:null
                };
        case GET_DASHBOARD_FAIL:
            return{
                ...state,
                error:action.paylaod,
                success:false
            }
        default:
            return state;
    }
};

export default userReducer;